/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

import './settings';
import {polyfill} from "seamless-scroll-polyfill";
import {dispatchCustomEvent} from '@dvrd/dvr-controls';
import IDate from '@dvrd/idate';
import {setDeviceId} from "./utils";

declare global {
    interface Window {
        log: Function;
        mode: string;
        settings: Record<string, any>;
        modeSettings: { [index: string]: any };
        dce: Function;
        allowCookies: boolean;
        dataLayer: any;
        gtag?: Function;
    }
}

polyfill({});
setDeviceId();
IDate.setLocale('nl-NL');
window.allowCookies = true;
window.dce = (event: string, data?: any) => {
    dispatchCustomEvent(event, data);
};